import { render, staticRenderFns } from "./full-course.vue?vue&type=template&id=c6706254&scoped=true"
import script from "./full-course.vue?vue&type=script&lang=js"
export * from "./full-course.vue?vue&type=script&lang=js"
import style0 from "./full-course.vue?vue&type=style&index=0&id=c6706254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6706254",
  null
  
)

export default component.exports